export const formatQueryStringForObject = (sortingParams, sortKeyword) => {
  const queryString = Object.entries(sortingParams)
    .map(([key, value]) => `${sortKeyword}[${key}]=${value}`)
    .join('&')

  return queryString || ''
}
